import axios from "axios";
import { sisikong_url } from "..";

type Subagent = {
  id: number;
  name: string;
  legal_title: string;
  email: string;
};

export function getLeanSubagents(
  source_entity: string,
): Promise<{ data: { results: Subagent[]; count: number } }> {
  return axios.get(`${sisikong_url}/crm/external/lean-sub-agents-list`, {
    params: { source_entity },
  });
}
